@if (selectedPeriod$ | async; as period) {
    <div class="report-wrapper" [@.disabled]="true">
        @if (getFilenameFromDateRange(period.dateRange, period.from, period.to); as reportDate) {
            <div class="page-wrapper start-background flex flex-col p-14 justify-between">
                <img src="assets/logos/sewio-hid-logo-color-safe-zone-rgb.png" class="w-[200px]" />
                <div class="flex flex-col h-1/2 px-14">
                    @if (selectedSiteName$ | async; as selectedSiteName) {
                        @if (selectedCompanyName$ | async; as selectedCompanyName) {
                            <div class="text-brand font-medium text-[50px] mb-14">myRTLS Report</div>
                            <div class="flex flex-col text-[20px]">
                                <div>{{ selectedSiteName }}</div>
                                <div>{{ selectedCompanyName }}</div>
                                <div>{{ reportDate }}</div>
                                @if (currentLicense$ | async; as license) {
                                    @if (isExpiring(license.expiration)) {
                                        <div class="text-warning mt-7">Your myRTLS license will expire soon.</div>
                                    }
                                }
                            </div>
                            @if (metricsLoaded && alertsLoaded) {
                                <div id="report-title"></div>
                            }
                        }
                    }
                </div>
            </div>
            @for (overviewPage of overviewPages; track overviewPage; let overviewIndex = $index) {
                <div class="page-break p-8 flex flex-col min-h-[100vh]">
                    <div class="flex pb-4 mb-4 justify-between border-b border-dark-300">
                        <div>
                            System Overview
                            @if (overviewPages.length !== 1) {
                                <span class="text-xs mx-2 text-dark-400"> page {{ overviewIndex + 1 }} out of {{ overviewPages.length }}</span>
                            }
                        </div>
                        <div>{{ reportDate }}</div>
                    </div>
                    <div class="flex-grow">
                        @if (overviewPage.bars.length) {
                            <myrtls-ratio-bar-widget [data]="overviewPage.bars" [showInfo]="false"></myrtls-ratio-bar-widget>
                        }
                        @if (overviewPage.stats.length) {
                            <myrtls-single-stat-widget [data]="overviewPage.stats" [showInfo]="false"></myrtls-single-stat-widget>
                        }
                    </div>
                    <div class="flex pt-4 mt-4 justify-between border-t border-dark-300">
                        <div></div>
                        <img src="assets/logos/sewio-hid-logo-color-safe-zone-rgb.png" class="w-[100px]" />
                    </div>
                </div>
            }
            @if (paginatedData.length > 0) {
                @for (page of paginatedData; track page; let pageIndex = $index) {
                    <div class="page-break p-8 min-h-[100vh] flex flex-col">
                        <div class="flex pb-4 mb-4 justify-between border-b border-dark-300">
                            <div>
                                Pending Alerts
                                @if (pagesCount !== 1) {
                                    <span class="text-xs mx-2 text-dark-400"> page {{ pageIndex + 1 }} out of {{ pagesCount }}</span>
                                }
                            </div>
                            <div>{{ reportDate }}</div>
                        </div>
                        <div class="flex-grow">
                            <table #alerts mat-table [dataSource]="page" class="break-inside-auto">
                                <ng-container matColumnDef="metric">
                                    <th mat-header-cell *matHeaderCellDef>Metric</th>
                                    <td mat-cell *matCellDef="let element">
                                        <span class="text-error">{{ element.metric }}</span>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="metadata">
                                    <th mat-header-cell *matHeaderCellDef>ID</th>
                                    <td mat-cell *matCellDef="let element">{{ element.metadata }}</td>
                                </ng-container>
                                <ng-container matColumnDef="from">
                                    <th mat-header-cell *matHeaderCellDef>Alert pending since</th>
                                    <td mat-cell *matCellDef="let element">{{ element.from | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="columns"></tr>
                                <tr mat-row *matRowDef="let row; columns: columns"></tr>
                            </table>
                        </div>
                        <div class="flex pt-4 mt-4 justify-between border-t border-dark-300">
                            <div></div>
                            <img src="assets/logos/sewio-hid-logo-color-safe-zone-rgb.png" class="w-[100px]" />
                        </div>
                    </div>
                }
            } @else {
                <div class="page-break p-8 min-h-[100vh] flex flex-col">
                    <div class="flex pb-4 mb-4 justify-between border-b border-dark-300">
                        <div>Pending Alerts</div>
                        <div>{{ reportDate }}</div>
                    </div>
                    <div class="flex-grow">
                        <div class="text-center text-base">No pending alerts.</div>
                    </div>
                    <div class="flex pt-4 mt-4 justify-between border-t border-dark-300">
                        <div></div>
                        <img src="assets/logos/sewio-hid-logo-color-safe-zone-rgb.png" class="w-[100px]" />
                    </div>
                </div>
            }
            @if (siteReportMetrics$ | async; as reportMetrics) {
                @if (chartOptions$ | async; as metrics) {
                    @for (metric of metrics | sortMetricsByIdsArray: reportMetrics; track metricById($index, metric)) {
                        @if (metric && reportMetrics.includes(metric.id)) {
                            @for (tableRows of tablePages(metric); track tableRows; let tablePageIndex = $index; let tablePagesCount = $count) {
                                <div class="page-break p-8 min-h-[100vh] flex flex-col">
                                    <div class="flex pb-4 mb-4 justify-between border-b border-dark-300">
                                        <div>
                                            {{ metric.name }}<span class="text-xs mx-2 text-dark-400">{{ metric.nameSuffix }}</span>
                                            @if (tablePagesCount !== 1) {
                                                <span class="text-xs mx-2 text-dark-400">
                                                    page {{ tablePageIndex + 1 }} out of {{ tablePagesCount }}</span
                                                >
                                            }
                                        </div>
                                        <div>{{ reportDate }}</div>
                                    </div>
                                    <div class="flex-grow">
                                        @if (metric.options; as options) {
                                            @if (tablePageIndex === 0) {
                                                <div
                                                    class="canvas-wrapper"
                                                    echarts
                                                    [options]="options"
                                                    [style.height]="getChartHeight(metric.id, options)"
                                                    (chartFinished)="onChartRendered(metric.id)"
                                                ></div>
                                            }
                                        }
                                        @if (metric.tableOptions; as options) {
                                            <div #table class="table-container" [attr.metricId]="metric.id">
                                                <table class="break-inside-auto" mat-table [dataSource]="tableRows">
                                                    @for (column of options.columns; track column) {
                                                        <ng-container [matColumnDef]="column.name">
                                                            <th mat-header-cell *matHeaderCellDef>{{ column.alias }}</th>
                                                            <td
                                                                mat-cell
                                                                *matCellDef="let element"
                                                                [style.color]="element[column.name].color ? element[column.name].color : '#000'"
                                                            >
                                                                @if (Array.isArray(element[column.name].value)) {
                                                                    <myrtls-state-timeline
                                                                        class="w-[500px]"
                                                                        [data]="element[column.name].value"
                                                                        [colorMapping]="element[column.name].colorMapping"
                                                                    ></myrtls-state-timeline>
                                                                }
                                                                @if (!Array.isArray(element[column.name].value)) {
                                                                    <div>{{ element[column.name].value }}</div>
                                                                }
                                                            </td>
                                                        </ng-container>
                                                    }
                                                    <tr class="no-data-row" *matNoDataRow>
                                                        <td class="mat-cell no-data" colspan="9999">{{ options.noDataText || 'No data found.' }}</td>
                                                    </tr>
                                                    <tr mat-header-row *matHeaderRowDef="getColumns(options); sticky: false"></tr>
                                                    <tr
                                                        class="break-inside-avoid break-after-auto h-6 odd:bg-dark-50"
                                                        mat-row
                                                        *matRowDef="let row; columns: getColumns(options)"
                                                    ></tr>
                                                </table>
                                            </div>
                                        }
                                    </div>
                                    <div class="flex pt-4 mt-4 justify-between border-t border-dark-300">
                                        <div></div>
                                        <img src="assets/logos/sewio-hid-logo-color-safe-zone-rgb.png" class="w-[100px]" />
                                    </div>
                                </div>
                            }
                        }
                    }
                }
            }
            <div class="page-wrapper end-background flex flex-col p-14 justify-between">
                <img src="assets/logos/sewio-hid-logo-color-safe-zone-rgb.png" class="w-[200px]" />
                <div class="flex flex-col h-1/2 px-14">
                    <div class="text-brand font-medium text-[50px] mb-14">Thank you<br />for using our product</div>
                    <div class="flex flex-col text-[20px]">
                        <div>
                            If you have any questions or feedback, please
                            <a target="_blank" href="https://docs.sewio.net/docs/how-to-make-a-support-ticket-25593561.html">open a ticket</a> and
                            reach out to our CX team.
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
}
